/* eslint-disable
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
class LeavingSearchScopeModalController {
   $scope: any
   $uibModalInstance: any
   dialogService: DialogService
   searchScopeService: SearchScopeService
   appState: AppStateService
   advancedSearch: AdvancedSearchService
   constructor($scope: any, $uibModalInstance: any, dialogService: DialogService, searchScopeService: SearchScopeService, appState: AppStateService, translationService: TranslationService, advancedSearchService: AdvancedSearchService) {
      this.$scope = $scope
      this.leave = this.leave.bind(this)
      this.cancel = this.cancel.bind(this)
      this.getCurrentScope = this.getCurrentScope.bind(this)
      this.$uibModalInstance = $uibModalInstance
      this.dialogService = dialogService
      this.searchScopeService = searchScopeService
      this.appState = appState
      this.$scope.leave = this.leave
      this.$scope.cancel = this.cancel
      this.$scope.getCurrentScope = this.getCurrentScope
      this.$scope.i18n = translationService
      this.advancedSearch = advancedSearchService
   }

   $onInit() {
      return this.$uibModalInstance.result
      // not handling errors in dialog closing, just catch the close
         .then((res: any) => {
            return
         }).catch((res: any) => {
            return
         })
   }

   removeSearchScopeAndUpdateState(){
      const setState = () => {
         this.searchScopeService.setDefaultScope()
         //set page to 1
         this.appState.params.pn = 1
      }
      this.appState.applyStateWithSnapShot(setState)
   }

   getCurrentScope() {
      return this.searchScopeService.warningMetaData.scopeLabel || this.searchScopeService.currentSearchScope?.label
   }

   executeLeaveCallback(){
      if(this.searchScopeService.warningMetaData.callBack){
         const goBackToSearchScope = false
         if (this.searchScopeService.warningMetaData.callbackDateParams){
            this.searchScopeService.warningMetaData.callBack(goBackToSearchScope, this.searchScopeService.warningMetaData.callbackDateParams)
         } else {
            this.searchScopeService.warningMetaData.callBack(goBackToSearchScope)
         }
      }
   }

   leave($event: any) {
      if(this.searchScopeService.warningMetaData.fromAdvanced){
         this.advancedSearch.clearSearchScopeFromAdvanced()
         this.executeLeaveCallback()
      } else {
         this.executeLeaveCallback()
         this.removeSearchScopeAndUpdateState()
      }
      
      this.searchScopeService.$uibModalInstance.close('close modal')
      this.searchScopeService.$uibModalInstance = undefined
   }

   cancel($event: any) {
      if(this.searchScopeService.warningMetaData.callBack){
         const goBackToSearchScope = true
         this.searchScopeService.warningMetaData.callBack(goBackToSearchScope)
      }
      this.searchScopeService.$uibModalInstance.close('close modal')
      this.searchScopeService.$uibModalInstance = undefined
   }

}

LeavingSearchScopeModalController.$inject = ['$scope', '$uibModalInstance', 'dialogService', 'searchScopeService', 'appStateService', 'translationService', 'advancedSearchService']

angular.module('summonApp.controllers')
   .controller('LeavingSearchScopeModalCtrl', LeavingSearchScopeModalController)
